import { DateTime } from 'luxon';
import { downloadInvoicePdf, getOptionalInvoiceReference } from '../services/accountingDocuments';

const ACCOUNTING_CSV_HEADERS = [
  'Date',
  'Type',
  'TTC',
  'TVA',
  'HT',
  'Moyen',
  'Client',
  'Référence'
];

function downloadTextFile(content, filename, mimeType) {
  const blob = new Blob([content], { type: mimeType });
  const link = document.createElement('a');

  if (link.download === undefined) {
    return;
  }

  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

function getPlatformLabelForCsv(platform) {
  const platformMap = {
    paypal: 'PayPal',
    lydia: 'Lydia',
    cash: 'Espèces',
    bank_transfer: 'Virement',
    card: 'Carte',
    other: 'Autre'
  };

  return platformMap[platform] || platform || '-';
}

export function buildAccountingPreviewData(reservations, selectedYear, selectedMonth) {
  return [...reservations]
    .filter((reservation) => reservation.final_payment_received)
    .sort((left, right) => {
      const leftDate = left.final_payment_date ? new Date(left.final_payment_date) : new Date(0);
      const rightDate = right.final_payment_date ? new Date(right.final_payment_date) : new Date(0);
      return leftDate - rightDate;
    })
    .map((reservation) => {
      let date = '-';
      let paymentDateIso = null;
      let refYear = selectedYear;
      let refMonth = String(selectedMonth).padStart(2, '0');

      if (reservation.final_payment_date) {
        try {
          const paymentDate = DateTime.fromISO(reservation.final_payment_date, { zone: 'utc' }).setZone('Europe/Paris');
          paymentDateIso = paymentDate.toISODate();
          date = paymentDate.toFormat('dd/MM/yyyy');
          refYear = paymentDate.year;
          refMonth = String(paymentDate.month).padStart(2, '0');
        } catch {
          date = '-';
        }
      }

      const ttc = parseFloat(reservation.final_payment_amount) || 0;
      const ht = ttc / 1.2;
      const tva = ttc - ht;

      return {
        id: reservation.id,
        source_type: 'tattoo',
        source_id: reservation.id,
        payment_date: paymentDateIso,
        payment_date_original: paymentDateIso,
        date,
        type: 'Tattoo',
        ttc: ttc.toFixed(2),
        tva: tva.toFixed(2),
        ht: ht.toFixed(2),
        moyen: getPlatformLabelForCsv(reservation.final_payment_platform),
        client: reservation.client_instagram || reservation.client_name || '-',
        refYear,
        refMonth
      };
    });
}

export function downloadAccountingCsv(selectedData, selectedYear, selectedMonth) {
  const csvData = selectedData.map((row) => {
    const reference = getOptionalInvoiceReference(row, '');
    return [
      row.date,
      row.type,
      row.ttc,
      row.tva,
      row.ht,
      row.moyen,
      row.client,
      reference
    ];
  });

  const csvContent = [ACCOUNTING_CSV_HEADERS, ...csvData]
    .map((row) => row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(','))
    .join('\n');

  const filename = `tattoo_${selectedYear}_${String(selectedMonth).padStart(2, '0')}.csv`;
  downloadTextFile(`\uFEFF${csvContent}`, filename, 'text/csv;charset=utf-8;');
}

export function downloadAccountingFacturePdf(selectedData, selectedYear, selectedMonth) {
  const issuedData = selectedData.filter(row => row.invoice_reference);
  if (issuedData.length === 0) return;
  downloadInvoicePdf(issuedData, { type: 'tattoo', year: selectedYear, month: selectedMonth });
}
